$(function() {
  $('#exportOperationLists').on('click', function(e) {
    $.ajax({
      url: '/reports/export-operation-lists',
      type: 'GET',
      data: {
        q: location.search.slice(1),
      },
      error: function() {
        // callback()
      },
      success: function(data) {
        $('#operation-lists-export').html(data)

        $('#operation-lists-export')
          .first()
          .table2csv()
        return false
      },
    })
  })
})
